module.exports = __webpack_public_path__ + "img/user.c66412bd.png";